<template>
  <HeadingLv1 text="退会完了" />
  <div class="u-containar">
    <div style="margin-bottom:30px;">
      退会処理を完了しました。<br>
      ご利用ありがとうございました。<br>
      <br>
      ※ヒポクラ✕マイナビの変更・退会はヒポクラ✕マイナビサービス側で実施してください。
    </div>

    <form v-on:submit="$router.push('/')">

    <div class="buttons">
      <Button
        label="トップページに戻る"
        :handleClick="confirm"
        primary
      />
    </div>
    </form>
  </div>
</template>

<script lang="ts">
import { onMounted, reactive, ref } from 'vue'
import Button from '@/components/elements/Button.vue'
import HeadingLv1 from '@/components/elements/HeadingLv1.vue'
import FormSelectField from '@/components/block/FormSelectField.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { useRouter } from 'vue-router'

export default {
  props: {
    answer: Number,
    answer_comment: String,
  },

  name: 'MypageLeaveInput',

  components: {
    Button,
    HeadingLv1,
  },

  setup(props: any) {
    const router = useRouter()
    const state = reactive<any>({
      enableRequest: false,
      hasRequestableHospital: false,
      isLoading: true
    })

    const csrf = ref(
      document.querySelector('meta[name="csrf-token"]')!.getAttribute('content')
    )

    interface SelectObject {
      label: string
      value: string
      selected: boolean
    }

    const selectDefault = {
      label: '選択してください',
      value: '',
      selected: false
    }

    const confirm = () => {
      router.push('/');
    }

    onMounted(() => {
      const getList = axiosSetting('app', 'page')
    })

    return {
      csrf,
      state,
      FormSelectField,
      confirm,
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.reqBtn {
  @include mixins.media() {
    .button {
      margin-right: 0;
    }
  }
}

::v-deep(.headingLv2) {
  margin-top: 50px;
  margin-bottom: 35px;

  & + .button {
    max-width: 88%;
  }
}

.fixedArea {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding-right: 8px;
  padding-left: 8px;
  z-index: 100;
  height: 72px;
  background: #fff;
  box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
}

.fixedArea .button {
  margin-left: 8px;
  margin-right: 8px;
  max-width: 224px;

  &:first-child {
    flex-shrink: 2;
  }

  &:last-child {
    flex-grow: 1;
  }
}

// ::v-deep(.goalButtons) {
//   position: fixed;
//   bottom: 55px;
//   width: 100%;
//   padding-right: 15px;
//   padding-left: 15px;
//   background: #fff;
//   z-index: 100;
// }

// .fixedArea

// ::v-deep(.goalButtons .button) {
//   max-width: none;
//   flex-basis: 85px;
//   flex-grow: 0;
//   width: auto;
// }

// ::v-deep(.goalButtons .button.primary) {
//   flex-grow: 1;
// }
.buttons {
  display: flex;
  justify-content: center;
  margin: 45px -16px 0;
  padding: 10px 8px;
  background-color: #f5f5f5;

  @include mixins.media() {
    margin: 70px 0 0;
    background-color: transparent;
  }

  .button {
    margin: 0 4px;

    @include mixins.media() {
      margin: 0 8px;
    }
  }
}
</style>
